import { useMemo } from 'react';
import { useDecision } from '@optimizely/react-sdk';

import { NewBadgeDecisionVariables } from '@/builders/pizza/setters/Toppings/ToppingsPicker/hooks/useNewToppingBadge';

const useShowNewBadge = (productId?: string): { shouldShowNewBadge: boolean } => {
  // TODO: Refactor this to pull from a CMS one day for new badges on products
  const [{
    enabled: isFeatureFlagEnabled,
    variables: decisionVariables
  }] = useDecision('fr-dtg-802-yum-show-new-badge', { autoUpdate: true });

  const decisionNewRecipesBadge = (decisionVariables as NewBadgeDecisionVariables)?.new_recipes_badge;

  const shouldShowNewBadge = useMemo(() => {
    const newRecipesIdList = decisionNewRecipesBadge?.recipes?.ids ?? [];
    // Doing it this way so any product id substring match will work. So we can add many Ids (Yum/QO/Some future system)
    return isFeatureFlagEnabled && !!productId && newRecipesIdList.some((recipe) => productId.includes(recipe));
  }, [decisionNewRecipesBadge?.recipes?.ids, isFeatureFlagEnabled, productId]);

  return { shouldShowNewBadge };
};

export default useShowNewBadge;
